(() => {
  const init = () => {
    const root = document.querySelector('[data-coolmist-clean-page]');
    if (root?.dataset.cmVideoMode === 'inline') return;
    const strip = root?.querySelector('[data-slider="social"]');
    if (!strip || strip.dataset.marqueeReady) return;
    strip.dataset.marqueeReady = 'true';
    const isThemeEditor = Boolean(window.Shopify?.designMode);
    const allowVideoPreview = !isThemeEditor;
    const originals = [...strip.children];
    const dialog = root.querySelector('.cm-clean-video-dialog');
    const player = dialog?.querySelector('video');
    const status = dialog?.querySelector('[role="status"]');
    const motion = root.querySelector('[data-video-motion]');
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    let userPaused = reduced.matches;
    let inView = false;
    let hovering = false;
    let pointerDown = false;
    let keyboardFocus = false;
    let manualUntil = 0;
    let suppressClickUntil = 0;
    let span = 0;
    let position = 0;
    let previousTime = 0;
    let frame = 0;
    let returnButton;
    let previousOverflow = '';
    let playerGeneration = 0;

    const duplicate = () => originals.map(card => {
      const copy = card.cloneNode(true);
      copy.setAttribute('aria-hidden', 'true');
      const button = copy.querySelector('button');
      if (button) button.tabIndex = -1;
      return copy;
    });
    if (!isThemeEditor) {
      strip.prepend(...duplicate());
      strip.append(...duplicate());
    }
    const cards = [...strip.children];
    const videos = cards.map(card => card.querySelector('video'));
    const visibleVideos = new Set();
    const previewAllowed = () => allowVideoPreview && inView && !document.hidden && !dialog?.open && !userPaused;
    const syncPreviews = () => {
      const activeVideo = previewAllowed() ? [...visibleVideos][0] : null;
      videos.forEach(video => {
        if (!video) return;
        if (video === activeVideo) {
          video.muted = true;
          if (video.paused) video.play().catch(() => {});
        } else video.pause();
      });
    };
    const videoObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const video = entry.target.querySelector('video');
        if (!video) return;
        if (entry.isIntersecting) visibleVideos.add(video);
        else visibleVideos.delete(video);
      });
      syncPreviews();
    }, { root: strip, threshold: 0.05 });
    cards.forEach(card => videoObserver.observe(card));

    const normalize = value => {
      if (!span) return value;
      while (value < span * 0.5) value += span;
      while (value >= span * 1.5) value -= span;
      return value;
    };
    const writePosition = value => {
      position = normalize(value);
      strip.scrollLeft = position;
    };
    const measure = () => {
      if (!originals[0] || !cards[0]) return;
      const nextSpan = originals[0].offsetLeft - cards[0].offsetLeft;
      if (!nextSpan) return;
      const progress = span ? (strip.scrollLeft - span) / span : 0;
      span = nextSpan;
      writePosition(span * (1 + progress));
    };
    new ResizeObserver(measure).observe(strip);
    measure();

    const canMove = now => allowVideoPreview && !userPaused && inView && !document.hidden && !dialog?.open && !hovering && !pointerDown && !keyboardFocus && now >= manualUntil;
    const tick = now => {
      const elapsed = previousTime ? Math.min(now - previousTime, 80) : 0;
      previousTime = now;
      if (canMove(now)) writePosition(position - elapsed * 0.03);
      else position = strip.scrollLeft;
      frame = requestAnimationFrame(tick);
    };
    if (!isThemeEditor) frame = requestAnimationFrame(tick);
    const sectionObserver = new IntersectionObserver(entries => {
      inView = entries[0].isIntersecting;
      syncPreviews();
    });
    sectionObserver.observe(strip);
    document.addEventListener('visibilitychange', () => {
      previousTime = 0;
      syncPreviews();
    });
    const updateMotion = () => {
      if (motion) {
        motion.textContent = userPaused ? 'Resume motion' : 'Pause motion';
        motion.setAttribute('aria-pressed', String(userPaused));
      }
      syncPreviews();
    };
    motion?.addEventListener('click', () => { userPaused = !userPaused; updateMotion(); });
    reduced.addEventListener('change', () => { userPaused = reduced.matches; updateMotion(); });
    updateMotion();
    strip.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') hovering = true; });
    strip.addEventListener('pointerleave', () => { hovering = false; });
    strip.addEventListener('focusin', event => { keyboardFocus = event.target.matches(':focus-visible'); });
    strip.addEventListener('focusout', event => { if (!strip.contains(event.relatedTarget)) keyboardFocus = false; });
    strip.addEventListener('wheel', () => { manualUntil = performance.now() + 1500; }, { passive: true });
    strip.addEventListener('scroll', () => {
      if (pointerDown || performance.now() < manualUntil || keyboardFocus) position = strip.scrollLeft;
    }, { passive: true });

    root.querySelectorAll('[data-slider]').forEach(slider => {
      let drag;
      slider.addEventListener('pointerdown', event => {
        if (event.button !== 0 || event.target.closest('button, a, input')) return;
        if (slider === strip) pointerDown = true;
        drag = { id: event.pointerId, x: event.clientX, left: slider.scrollLeft, moved: false, mouse: event.pointerType === 'mouse' };
      });
      slider.addEventListener('pointermove', event => {
        if (!drag || drag.id !== event.pointerId) return;
        const delta = event.clientX - drag.x;
        if (Math.abs(delta) > 6) {
          drag.moved = true;
          if (drag.mouse) {
            slider.setPointerCapture(event.pointerId);
            slider.classList.add('is-dragging');
          }
        }
        if (drag.mouse && drag.moved) {
          event.preventDefault();
          slider.scrollLeft = drag.left - delta;
        }
      });
      const end = event => {
        if (!drag || drag.id !== event.pointerId) return;
        if (drag.moved) suppressClickUntil = performance.now() + 350;
        if (slider.hasPointerCapture(event.pointerId)) slider.releasePointerCapture(event.pointerId);
        slider.classList.remove('is-dragging');
        if (slider === strip) {
          pointerDown = false;
          manualUntil = performance.now() + 1500;
          position = slider.scrollLeft;
        }
        drag = null;
      };
      window.addEventListener('pointerup', end);
      window.addEventListener('pointercancel', end);
    });
    root.querySelectorAll('[data-slider-prev="social"], [data-slider-next="social"]').forEach(button => {
      button.addEventListener('click', () => {
        manualUntil = performance.now() + 1500;
        const step = originals[0].getBoundingClientRect().width + parseFloat(getComputedStyle(strip).columnGap);
        const direction = button.hasAttribute('data-slider-prev') ? -1 : 1;
        writePosition(strip.scrollLeft + direction * step);
      });
    });

    const openVideo = card => {
      if (!dialog || !player) return;
      const preview = card.querySelector('video');
      const source = preview?.querySelector('source');
      if (!preview || !source?.src) return;
      const generation = ++playerGeneration;
      returnButton = card.querySelector('button');
      if (status) status.textContent = '';
      root.querySelectorAll('video').forEach(video => video.pause());
      player.src = source.src;
      player.poster = preview.poster;
      player.muted = false;
      previousOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      dialog.showModal();
      player.play().catch(error => {
        if (generation !== playerGeneration || !dialog.open || error.name === 'AbortError') return;
        if (status) status.textContent = 'Tap the video play control to start playback.';
      });
    };
    if (dialog && player) {
      strip.addEventListener('click', event => {
        if (performance.now() < suppressClickUntil) return;
        const card = event.target.closest('.cm-clean-social-card');
        if (card) openVideo(card);
      });
      player.addEventListener('error', () => { if (dialog.open && status) status.textContent = 'This video could not load. Please close it and try again.'; });
      player.addEventListener('playing', () => { if (status) status.textContent = ''; });
      dialog.querySelector('.cm-clean-video-close')?.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      });
      dialog.addEventListener('close', () => {
        playerGeneration++;
        player.pause();
        player.removeAttribute('src');
        player.load();
        document.documentElement.style.overflow = previousOverflow;
        returnButton?.focus({ preventScroll: true });
        keyboardFocus = returnButton?.matches(':focus-visible') || false;
        manualUntil = performance.now() + 500;
        syncPreviews();
      });
    }
    window.addEventListener('pagehide', () => {
      cancelAnimationFrame(frame);
      videos.forEach(video => video?.pause());
      player?.pause();
    });
    window.addEventListener('pageshow', event => {
      if (event.persisted && !isThemeEditor) {
        previousTime = 0;
        frame = requestAnimationFrame(tick);
        syncPreviews();
      }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
